import { useAppSelector } from '../../data/store';
import PlaylistItem from './playlist-item';
import { CONTAINER_SIZE } from '../video';

const Playlist = () => {

    const data = useAppSelector(store => store.root.data);

    return (
        <div className="text-xl flex-col flex max-w-full mx-auto lg:ml-0 lg:mr-4 order-1 lg:order-none mt-8 lg:mt-0 border-t lg:border-t-0 pt-8 lg:pt-0" style={{
            width: CONTAINER_SIZE
        }}>
            {
                data?.presets?.map(playlistItem => {
                    return (
                        <PlaylistItem
                            key={ playlistItem.id }
                            playlistItem={ playlistItem }
                        />
                    )
                })
            }
        </div>
    )
};

export default Playlist;